import { Box } from '@lingoda/ui';
import { colorsPalette, styled } from '@lingoda/ui/theme';

export interface ErrorLayoutProps {
    errorType: 400 | 404 | 500;
    customMessage?: string;
}

export const Wrapper = styled(Box)(({ theme }) => ({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: colorsPalette.primarySolid[8],
    overflow: 'hidden',
    minHeight: 'calc(100dvh - 56px - 60px)', // Minus header height and half of footer height

    [theme.breakpoints.up('sm')]: {
        minHeight: 'calc(100dvh - 64px - 60px)', // Minus header height and half of footer height
    },

    [theme.breakpoints.up('md')]: {
        minHeight: 'calc(100dvh - 64px)', // Minus header height
    },
}));

export const WaveWrapper = styled(Box)(() => ({
    position: 'absolute',
    zIndex: 1,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
}));
